export const FRONTEND = {
  COMMISSION_OFFERS: "/commission-offers",
  AGENCY_RATES: "/agency-rates",
  VENUE_NEWS: "/edge-venue-news",
  SPECIAL_OFFERS: "/special-offers",
  FAM_TRIPS: "/fam-trips",
  MOVERS_AND_SHAKERS: "/movers-and-shakers",
  RENOVATION_NEWS: "/renovation-news",
};
